export const REVIEW_ACTIVITY_TYPE = 'review'
export const REVIEWS_PAGE_SIZE = 15

export interface ListingReviewQueryParams {
  entityId?: string
  listingId?: string
  activityIndex: string
}

export const buildListingFilters = (listingId: string, selectedPlatform?: string | null): Record<string, string>[] => {
  const filter: Record<string, string> = { revenueSource: listingId }
  if (selectedPlatform) {
    filter.activitySource = selectedPlatform
  }
  return [filter]
}
